import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { on, select, addClass, removeClass, setAttribute, getAttribute, selectAll } from 'helpers/dom'

const selectors = {
  TOGGLE_SELECTOR: '.js-toggle-dropdown',
  CLOSE_BUTTON_SELECTOR: '.js-close-dropdown',
  OVERLAY_SELECTOR: '.js-top-bar-overlay',
  DROPDOWN_SELECTOR: '.js-top-bar-dropdown',
  ACTIVE_CLASS: 'dropdown-is-active',
  TIMEOUT: 301,
  TITLE_NZ_SELECTOR: '.js-title-nz',
  TITLE_AU_SELECTOR: '.js-title-au',
  CONTENT_BLOCK_NZ_SELECTOR: '.js-content-block-nz',
  CONTENT_BLOCK_AU_SELECTOR: '.js-content-block-au',
  HIDDEN_CLASS: 'hidden',
  FLEX_CLASS: 'flex'
}

class TopBar extends HTMLElement {
  constructor () {
    super()

    this.toggleEl = select(selectors.TOGGLE_SELECTOR, this)
    this.closeButton = select(selectors.CLOSE_BUTTON_SELECTOR, this)
    this.overlayEl = select(selectors.OVERLAY_SELECTOR, this)
    this.dropdownEl = select(selectors.DROPDOWN_SELECTOR, this)
    this.titleNzEl = select(selectors.TITLE_NZ_SELECTOR, this)
    this.titleAuEl = select(selectors.TITLE_AU_SELECTOR, this)
    this.contentAuEls = selectAll(selectors.CONTENT_BLOCK_AU_SELECTOR, this)
    this.contentNzEls = selectAll(selectors.CONTENT_BLOCK_NZ_SELECTOR, this)
  }

  connectedCallback () {
    if (this.toggleEl) {
      on('click', this.toggleDropdown.bind(this), this.toggleEl)
    }

    if (this.closeButton) {
      on('click', () => {
        this.hideDropdown(true)
      }, this.closeButton)
    }

    if (this.overlayEl) {
      on('click', () => {
        this.hideDropdown(true)
      }, this.overlayEl)
    }

    on('keyup', this.handleKeyUp.bind(this), window)
    on('focusin', this.handleFocusIn.bind(this), window)

    this.handleContentOnMarket()
  }

  handleKeyUp (event) {
    if (event.key === 'Escape' && getAttribute('aria-expanded', this.toggleEl) === 'true') {
      this.hideDropdown(true)
    }
  }

  handleFocusIn (event) {
    if (!this.contains(event.target) && getAttribute('aria-expanded', this.toggleEl) === 'true') {
      this.hideDropdown()
    }
  }

  toggleDropdown () {
    const isExpanded = getAttribute('aria-expanded', this.toggleEl) === 'true'

    if (isExpanded) {
      this.hideDropdown(false)
    } else {
      this.showDropdown()
    }
  }

  showDropdown () {
    if (this.dropdownEl) {
      disableBodyScroll(this.dropdownEl)
    }

    setAttribute('aria-expanded', 'true', this.toggleEl)
    addClass(selectors.ACTIVE_CLASS, this)
  }

  hideDropdown (shouldFocus = false) {
    clearAllBodyScrollLocks()
    setAttribute('aria-expanded', 'false', this.toggleEl)
    removeClass(selectors.ACTIVE_CLASS, this)

    if (shouldFocus) {
      setTimeout(() => {
        this.toggleEl.focus()
      }, selectors.TIMEOUT)
    }
  }

  handleContentOnMarket() {
    const isMarketAu = window.location.href.includes('/en-au')

    if (this.titleNzEl && this.titleAuEl) {
      this.toggleClass(selectors.HIDDEN_CLASS, this.titleNzEl, isMarketAu)
      this.toggleClass(selectors.HIDDEN_CLASS, this.titleAuEl, !isMarketAu)
    }

    if (this.contentAuEls.length > 0 && this.contentNzEls.length > 0) {
      this.contentNzEls.forEach(contentNzEl => {
        this.toggleClass(selectors.HIDDEN_CLASS, contentNzEl, isMarketAu)
      })
      this.contentAuEls.forEach(contentAuEl => {
        this.toggleClass(selectors.HIDDEN_CLASS, contentAuEl, !isMarketAu)
        this.toggleClass(selectors.FLEX_CLASS, contentAuEl, isMarketAu)
      })
    }
  }

  toggleClass(className, element, condition) {
    if (condition) {
      addClass(className, element)
    } else {
      removeClass(className, element)
    }
  }
}

if (!customElements.get('TopBar')) {
  customElements.define('top-bar', TopBar)
}
